import hoursGlass from "../../assets/images/hourglass-loader.gif";
interface PropData {
  defaultHeight?: any;
  // When true, render the loader as a normal in-flow block centered inside its
  // container instead of using the global `.component-loader` fixed-position
  // overlay. Use this for embedded section loaders (e.g. inside a page card)
  // where you want the icon to sit within the available content area rather
  // than at a fixed viewport coordinate.
  inline?: boolean;
  // When true, render the loader as a full-viewport overlay with a dimmed
  // backdrop. Centered both horizontally and vertically. Use this when an
  // API call should block interaction with the whole page (e.g. fetching a
  // calendar's events). Unlike the default fixed-position behavior, this
  // covers the entire viewport from top:0 — not from top:20%.
  overlay?: boolean;
}
const CompoLoader = (props: PropData) => {
  if (props.overlay) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(0, 0, 0, 0.35)",
          zIndex: 1050,
        }}
      >
        <img src={hoursGlass} alt="" width={70} />
      </div>
    );
  }
  if (props.inline) {
    return (
      <div
        style={{
          minHeight: props?.defaultHeight ?? "300px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={hoursGlass} alt="" width={60} />
      </div>
    );
  }
  return (
    <div
      className="component-loader"
      style={{ minHeight: props?.defaultHeight }}
    >
      <div className="loader-icon">
        <img src={hoursGlass} alt="" width={60} />
      </div>
    </div>
  );
};
export default CompoLoader;
